import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { StyledCardContent } from "./Message.style";
import { getNotificationbyIdRequest } from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import BackButton from "components/shared/BackButton";
import ContactCM from "components/contactus";
import {Helmet} from "react-helmet";

export default function Message() {
  const params = useParams();
  const { request, loading } = useHttp();
  const [message, setMessage] = useState([]);

  const getArticle = useCallback(async () => {
    let res = await request({
      url: getNotificationbyIdRequest,
      values: params.messageId,
    });
    setMessage(res);
  }, [request, params.messageId]);

  useEffect(() => {
    getArticle();
  }, [getArticle]);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>پیام های من - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="پیام های من" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  پیام های من
                </Typography>
              </StyledCardContent>
              <CardContent>{message?.notification?.message}</CardContent>
              <Grid container style={{ paddingLeft: "30px", direction: "ltr" }}>
                <Grid item mt={3} mb={3} xs={12}>
                  <BackButton />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
